import { Component } from '@angular/core';
import { BasePageComponent } from '../../shared/components/base-page.component';
import { ScreenService, NavigationService, LocalizerService } from '../../shared';
import { AuthenticationManager } from '../../shared/services/authentication-manager';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.scss'
})
export class SignupComponent extends BasePageComponent {

  email: string = "";
  newPassword: string = "";
  repeatPassword: string = "";

  passwordFieldMode: "password" | "text" = "password";
  passwordButtonOptions = {
    icon: 'eyeopen',
    stylingMode: 'text',
    onClick: () => {
      this.passwordFieldMode = this.passwordFieldMode === "password" ? "text" : "password";
    },
  };

  readonly returnUrl: string | null = null;
  readonly isInvitationContext: boolean;

  constructor(private auth: AuthenticationManager,
    private navigation: NavigationService,
    private route: ActivatedRoute,
    localizer: LocalizerService,
    screen: ScreenService) {
    super(screen, localizer);
    this.auth.cancelSignUp();
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    this.isInvitationContext = this.returnUrl ? this.returnUrl.includes('invitation_code=') : false;
  }

  sendConfirmationCode() {
    if (this.isBusy) {
      return;
    }

    this.isBusy = true;
    this.auth.signUp(this.email, this.newPassword, this.repeatPassword).subscribe({
      next: this.signUpCompleted.bind(this),
      error: this.signUpFailed.bind(this)
    });
  }

  navigateToLogin() {
    this.navigation.navigateToLogin(this.returnUrl ?? undefined);
  }

  private signUpCompleted() {
    this.isBusy = false;
    this.displaySuccessNotification(this.localizer.getLocalizedString("Auth.SendEmailSuccess"));
    this.navigation.navigateToConfirmSignup(this.returnUrl ?? undefined);
  }

  private signUpFailed(error: any) {
    console.log(error);
    this.isBusy = false;
    const message = (typeof error === "string") ? error : null;
    this.displayError(message);
  }

}
